import React, { useState } from "react";
import SwiperCore, { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Chart from "react-google-charts";
import { STORAGE_KEY, SERVICE_CODE } from "constants/index";
import { BtnMore } from "pages";
import { numberWithCommas, cengoldAlert } from "lib/utils";
import { CengoldModal } from "../../components/CengoldModal";
import { btn_more } from "styles/img";
import { useLocalStorage } from "../../lib/useLocalStorage";

SwiperCore.use([Navigation, Pagination]);

const CHART_OPTION = {
  title: "",
  vAxis: {
    title: "",
  },
  hAxis: {
    title: "",
    slantedText: true,
  },
  chartArea: {
    left: 60,
    top: 10,
    bottom: 30,
    height: "100%",
    width: "100%",
  },
  height: "100%",
  width: "100%",
  tooltip: {
    isHtml: true,
  },
  // focusTarget: 'category',
};

const QuoteChart = ({ chartData }) => {
  const [serviceCode] = useLocalStorage(STORAGE_KEY.SERVICE_CODE);
  const color = serviceCode === SERVICE_CODE.OKINV ? "#7d4bd2" : "#5f8af7";

  const chartOption = { ...CHART_OPTION, colors: [color] };

  const pegChartData = [
    ["date", "price", { type: "string", role: "tooltip", p: { html: true } }],
  ];
  const pesChartData = [
    ["date", "price", { type: "string", role: "tooltip", p: { html: true } }],
  ];

  if (chartData?.peg) {
    chartData.peg.forEach((d) => {
      pegChartData.push([
        d.date,
        d.price,
        `<div class="today" style="margin-left: -60px;"><span>${numberWithCommas(
          d.price
        )}원</span></div>`,
      ]);
    });
  }
  if (chartData?.pes) {
    chartData.pes.forEach((d) => {
      pesChartData.push([
        d.date,
        d.price,
        `<div class="today" style="margin-left: -60px;"><span>${numberWithCommas(
          d.price
        )}원</span></div>`,
      ]);
    });
  }

  const [showSellModal, setShowSellModal] = useState(false);
  const onCloseModal = () => {
    setShowSellModal(false);
  };

  return (
    <div className="section">
      <div className="content">
        <div className="price">
          <span className="top">시세차트</span>
          <div className="chart_bg"></div>
          <div className="chart-swiper-wrapper">
            <Swiper
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              pagination={{
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function () {
                  return `<span class="dot swiper-pagination-bullet" style='width: 60px; height: 3px; background: ${color};'></span>`;
                },
              }}
            >
              <SwiperSlide>
                <div className="chart-wrapper">
                  <Chart
                    width={"98%"}
                    height={"400px"}
                    chartType="LineChart"
                    loader={<div>로딩중...</div>}
                    data={pegChartData}
                    options={chartOption}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="chart-wrapper">
                  <Chart
                    width={"98%"}
                    height={"400px"}
                    chartType="LineChart"
                    loader={<div>로딩중...</div>}
                    data={pesChartData}
                    options={chartOption}
                  />
                </div>
              </SwiperSlide>
              <div className="swiper-pagination"></div>
              <div slot="container-end" className="swiper-button-next"></div>
              <div slot="container-end" className="swiper-button-prev"></div>
            </Swiper>
          </div>
          <BtnMore
            className="btn_more apply_btn4"
            txt="시세차트 상세보기"
            imgSrc={btn_more}
            onClick={() => {
              setShowSellModal(true);
            }}
          />
        </div>
      </div>
      <CengoldModal
        visible={showSellModal}
        title={"시세차트 상세보기"}
        onClose={onCloseModal}
      >
        <div>최근 한달의 시세정보를 제공합니다.</div>
        <div>보다 상세한 시세차트는 비단앱에서</div>
        <div>확인하실 수 있습니다.</div>
      </CengoldModal>
    </div>
  );
};

export default QuoteChart;
